import React from 'react';
import { getLiftClass, getLiftColor, getLiftStatusColors } from "../../helpers/map";
import LabelLift from "../UI/LabelLift";
import LiftLabelTypeSeat from "./components/LiftLabelTypeSeat";
import LiftLine from "./components/LiftLine";

const Lift12 = ({ isOpen, state, activeLiftId }) => {
	const colors = getLiftColor(isOpen, state);
	return (
		<g id="Lift12"
			 className={getLiftClass(isOpen, activeLiftId === '12', state)}
			 transform="translate(2088.000000, 121.000000)"
		>
			<LiftLine x1="193.073829" y1="22.0447827" x2="12.4770243" y2="332.250226" color={colors[0]}/>

			<LiftLabelTypeSeat seatCount="4" coords="92.000000, 157.000000" colors={getLiftStatusColors(state, isOpen)} isOpen={isOpen} />
			<LabelLift isOpen={isOpen} text={<tspan x="-3" y="13">12</tspan>} coords="186.000000, 0.000000" state={state}/>

			<g id="Labe-lift" transform="translate(0.000000, 318.000000)">
				<circle fill={colors[1]} cx="13" cy="13" r="13"/>
				<circle fill="#FFFFFF" cx="13" cy="13" r="10"/>
			</g>

			<polygon
				fill={colors[2]}
				transform="translate(13.547130, 330.547130) scale(-1, 1) rotate(65.000000) translate(-13.547130, -330.547130) "
				points="8.04712957 330.54713 19.0471296 325.04713 16.6756423 330.54713 19.0471296 336.04713"/>
		</g>
	);
};


Lift12.propTypes = {};

export default Lift12;
